import React from "react";
import "./ringsViewHeader.scss";

function RingsViewHeader(props) {
  return (
    <div className="rings-view-header">
      <p className="rings-view-header__username paragraph">
        {props.woodcutText}
      </p>
      <p className="rings-view-header__date paragraph">{props.date}</p>
    </div>
  );
}

export default RingsViewHeader;
